import React, { FunctionComponent } from 'react';
import { ShoppingCartIcon } from '@lyse-as/formds-react/lib/icon/common';

import { addUpgradesToCartActionCreator } from 'src/state/cart/action-creators/add-upgrades-action-creator';
import { removeUpgradeFromCart } from 'src/state/cart/cart-slice';
import { selectItemFromCart } from 'src/state/cart/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';
import { useSelectUpgradeDecoderOrThrow } from 'src/hooks/use-select-upgrade-decoder';

import { Upgrade } from './upgrade';
import { StyledBinIcon, StyledDescription } from './upgrade-one-page.styled';

export const UpgradeOnePage: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const { upgrade: decodersInCart } = useAppSelector(selectItemFromCart);
  const { upgradableUnits } = useSelectUpgradeDecoderOrThrow();

  const getButtonAddProps = () => ({
    children: (
      <>
        <ShoppingCartIcon /> {i18n.page.upgradeOne.addToCart}
      </>
    ),
    onClick: () => dispatch(addUpgradesToCartActionCreator([upgradableUnits[0].mac])),
  });

  const getButtonRemoveProps = () => ({
    children: (
      <>
        <StyledBinIcon /> {i18n.page.upgradeOne.removeFromCart}
      </>
    ),
    onClick: () => dispatch(removeUpgradeFromCart()),
  });

  return (
    <Upgrade
      content={
        <StyledDescription variant="paragraph2" component="p">
          {i18n.page.upgradeOne.description}
        </StyledDescription>
      }
      buttonProps={{
        ...(decodersInCart.includes(upgradableUnits[0].mac) ? getButtonRemoveProps() : getButtonAddProps()),
      }}
    />
  );
};
